import axios from "axios";
import { URL_BASE } from "../config/url-server";

const clientId = localStorage.getItem("client")
const accessToken = localStorage.getItem("token")




export const palmMovements = async (page,limit,farmId,sectionId,lotId,palmId) => {
  const params = {page,limit,farmId,sectionId,lotId,palmId};
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "report/palm-movements",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};


export const supervisionMetrics = async (startDate, endDate,farmId,sectionId,lotId,userId) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "report/supervision-metrics",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};

export const supervisionMetricsDaily = async (startDate, endDate,farmId,sectionId,lotId,userId) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "report/supervision-metrics-daily",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};


export const consolidatedReport = async (page,limit,startDate, endDate,farmId,sectionId,lotId,userId) => {
  const params = {startDate,endDate,farmId,lotId,page,limit ,sectionId,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "report/consolidated-report",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};




export const detailedReport = async (page,limit,startDate, endDate,farmId,sectionId,lotId,userId,lineId) => {
  const params = {startDate,endDate,farmId,lotId,page,limit ,sectionId,userId,lineId };
  console.log("detailedReport",params)
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "report/detailed-report",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};


export const paymentReport = async (page,limit,startDate, endDate,farmId,sectionId,lotId,userId,price) => {
    console.log(price)
  const params = {startDate,endDate,farmId,lotId,page,limit ,sectionId,userId,price };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "report/payment-report",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};

export const consumptionReport = async (page,limit,startDate, endDate,farmId,sectionId,lotId,userId) => {  
  const params = {startDate,endDate,farmId,lotId,page,limit ,sectionId,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "report/consumption-report",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};


/////EXCEL CORREGIDOS////////////
/////EXCEL CORREGIDOS////////////
/////EXCEL CORREGIDOS////////////
/////EXCEL CORREGIDOS////////////



export const supervisionMetricsDailyExcel = async (startDate, endDate,farmId,sectionId,lotId,userId) => {
  console.log("excel corregido supervisionMetricsDailyExcel")
  const params = {startDate,endDate,farmId,lotId,clientId,sectionId,userId};
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}` }, params, responseType: 'blob' };
  try {
    const response = await axios.get(URL_BASE + "report/supervision-daily-excel", config);
    const contentType = response.headers['content-type'];
    if (contentType && contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
      return response.data; 
    } else {   
      const text = await response.data.text();
      const errorData = JSON.parse(text);
      throw new Error(errorData.message || "Error desconocido al generar el reporte.");
    }
  } catch (error) {
    return { error: error.message };
  }
};






export const metricsExcel = async (startDate, endDate,farmId,sectionId,lotId,userId) => {
  console.log("excel corregido")
  const params = {startDate,endDate,farmId,lotId,clientId,sectionId,userId};
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}` }, params, responseType: 'blob' };
  try {
    const response = await axios.get(URL_BASE + "report/metrics-excel", config);
    const contentType = response.headers['content-type'];
    if (contentType && contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
      return response.data; 
    } else {   
      const text = await response.data.text();
      const errorData = JSON.parse(text);
      throw new Error(errorData.message || "Error desconocido al generar el reporte.");
    }
  } catch (error) {
    return { error: error.message };
  }
};




export const paymentExcel = async (startDate, endDate,farmId,sectionId,lotId,userId,price) => {
  const params = {startDate,endDate,farmId,lotId,clientId ,sectionId,userId,price };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}` }, params, responseType: 'blob' };
  try {
    const response = await axios.get(URL_BASE + "report/payment-excel", config);
    const contentType = response.headers['content-type'];
    if (contentType && contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
      return response.data; 
    } else {   
      const text = await response.data.text();
      const errorData = JSON.parse(text);
      throw new Error(errorData.message || "Error desconocido al generar el reporte.");
    }
  } catch (error) {
    return { error: error.message };
  }
};






export const generateDetailedExcel = async (startDate, endDate,farmId,sectionId,lotId,userId) => {
  const params = {startDate,endDate,farmId,lotId,clientId ,sectionId,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}` }, params, responseType: 'blob' };
  try {
    const response = await axios.get(URL_BASE + "report/generate-detailed-excel", config);
    const contentType = response.headers['content-type'];
    if (contentType && contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
      return response.data; 
    } else {   
      const text = await response.data.text();
      const errorData = JSON.parse(text);
      throw new Error(errorData.message || "Error desconocido al generar el reporte.");
    }
  } catch (error) {
    return { error: error.message };
  }
};





export const consumptionExcel = async (startDate, endDate,farmId,sectionId,lotId,userId) => {
  const params = {startDate,endDate,farmId,lotId,clientId ,sectionId,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}` }, params, responseType: 'blob' };
  try {
    const response = await axios.get(URL_BASE + "report/consumption-excel", config);
    const contentType = response.headers['content-type'];
    if (contentType && contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
      return response.data; 
    } else {   
      const text = await response.data.text();
      const errorData = JSON.parse(text);
      throw new Error(errorData.message || "Error desconocido al generar el reporte.");
    }
  } catch (error) {
    return { error: error.message };
  }
};





export const generateConsolidatedExcel = async (startDate, endDate,farmId,sectionId,lotId,userId) => {
  const params = {startDate,endDate,farmId,lotId,clientId ,sectionId,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}` }, params, responseType: 'blob' };
  try {
    const response = await axios.get(URL_BASE + "report/generate-consolidated-excel", config);
    const contentType = response.headers['content-type'];
    if (contentType && contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
      return response.data; 
    } else {   
      const text = await response.data.text();
      const errorData = JSON.parse(text);
      throw new Error(errorData.message || "Error desconocido al generar el reporte.");
    }
  } catch (error) {
    return { error: error.message };
  }
};




export const generateHeatMapExcel = async (startDate, endDate,farmId,sectionId,lotId,userId) => {
  const params = {startDate,endDate,farmId,lotId,clientId ,sectionId,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}` }, params, responseType: 'blob' };
  try {
    const response = await axios.get(URL_BASE + "report/heat-map-excel", config);
    const contentType = response.headers['content-type'];
    if (contentType && contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
      return response.data; 
    } else {   
      const text = await response.data.text();
      const errorData = JSON.parse(text);
      throw new Error(errorData.message || "Error desconocido al generar el reporte.");
    }
  } catch (error) {
    return { error: error.message };
  }
};


export const generateFirstApplicationMapExcel = async (startDate, endDate,farmId,sectionId,lotId,userId) => {
  const params = {startDate,endDate,farmId,lotId,clientId ,sectionId,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}` }, params, responseType: 'blob' };
  try {
    const response = await axios.get(URL_BASE + "report/map-first-application-excel", config);
    const contentType = response.headers['content-type'];
    if (contentType && contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
      return response.data; 
    } else {   
      const text = await response.data.text();
      const errorData = JSON.parse(text);
      throw new Error(errorData.message || "Error desconocido al generar el reporte.");
    }
  } catch (error) {
    return { error: error.message };
  }
};



export const generateTrackingExcel = async (startDate, endDate,farmId,sectionId,lotId,userId,deadTime,role) => {
  const params = {startDate,endDate,farmId,lotId,clientId ,sectionId,userId,deadTime,role };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}` }, params, responseType: 'blob' };
  try {
    const response = await axios.get(URL_BASE + "report/tracking-excel", config);
    const contentType = response.headers['content-type'];
    if (contentType && contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
      return response.data; 
    } else {   
      const text = await response.data.text();
      const errorData = JSON.parse(text);
      throw new Error(errorData.message || "Error desconocido al generar el reporte.");
    }
  } catch (error) {
    return { error: error.message };
  }
};




export const generateAccumulationExcel = async (startDate, endDate,farmId,sectionId,lotId,userId) => {
  const params = {startDate,endDate,farmId,lotId,clientId ,sectionId,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}` }, params, responseType: 'blob' };
  try {
    const response = await axios.get(URL_BASE + "report/operator-lot-excel", config);
    const contentType = response.headers['content-type'];
    if (contentType && contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
      return response.data; 
    } else {   
      const text = await response.data.text();
      const errorData = JSON.parse(text);
      throw new Error(errorData.message || "Error desconocido al generar el reporte.");
    }
  } catch (error) {
    return { error: error.message };
  }
};


export const unproductivePalms = async (startDate, endDate,farmId,sectionId,lotId,userId) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "map/unproductive-palms",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};



export const accumulationByMonth = async (page,limit,startDate, endDate,farmId,sectionId,lotId,userId) => {
  const params = {startDate,endDate,farmId,lotId,page,limit ,sectionId,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "report/accumulation-by-month",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};


export const accumulationByMonthExcel = async (startDate, endDate,farmId,sectionId,lotId,userId) => {
  const params = {startDate,endDate,farmId,lotId,clientId ,sectionId,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}` }, params, responseType: 'blob' };
  try {
    const response = await axios.get(URL_BASE + "report/accumulation-by-month-excel", config);
    const contentType = response.headers['content-type'];
    if (contentType && contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
      return response.data; 
    } else {   
      const text = await response.data.text();
      const errorData = JSON.parse(text);
      throw new Error(errorData.message || "Error desconocido al generar el reporte.");
    }
  } catch (error) {
    return { error: error.message };
  }
};




export const fruitInventoryExcel = async (lotId,days) => {
  const params = {lotId,days};
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}` }, params, responseType: 'blob' };
  try {
    const response = await axios.get(URL_BASE + "report/fruit-inventory-excel", config);
    const contentType = response.headers['content-type'];
    if (contentType && contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
      return response.data; 
    } else {   
      const text = await response.data.text();
      const errorData = JSON.parse(text);
      throw new Error(errorData.message || "Error desconocido al generar el reporte.");
    }
  } catch (error) {
    return { error: error.message };
  }
};








export const generateTrackingExcelAll = async (startDate, endDate,farmId,sectionId,lotId,userId,deadTime,role) => {
  const params = {startDate,endDate,farmId,lotId,clientId ,sectionId,userId,deadTime,role };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}` }, params, responseType: 'blob' };
  try {
    const response = await axios.get(URL_BASE + "report/tracking-excel-all", config);
    const contentType = response.headers['content-type'];
    if (contentType && contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
      return response.data; 
    } else {   
      const text = await response.data.text();
      const errorData = JSON.parse(text);
      throw new Error(errorData.message || "Error desconocido al generar el reporte.");
    }
  } catch (error) {
    return { error: error.message };
  }
};




export const accumulationByLot = async (page,limit,startDate, endDate,farmId,sectionId,lotId,userId) => {
  const params = {startDate,endDate,farmId,lotId,page,limit ,sectionId,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "report/accumulation-by-lot",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};


export const accumulationByLotExcel = async (startDate, endDate,farmId,sectionId,lotId,userId) => {
  const params = {startDate,endDate,farmId,lotId,clientId ,sectionId,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}` }, params, responseType: 'blob' };
  try {
    const response = await axios.get(URL_BASE + "report/accumulation-by-lot-excel", config);
    const contentType = response.headers['content-type'];
    if (contentType && contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
      return response.data; 
    } else {   
      const text = await response.data.text();
      const errorData = JSON.parse(text);
      throw new Error(errorData.message || "Error desconocido al generar el reporte.");
    }
  } catch (error) {
    return { error: error.message };
  }
};







////GENERICOS EXCEL Y REPORTES
////GENERICOS EXCEL Y REPORTES
////GENERICOS EXCEL Y REPORTES
////GENERICOS EXCEL Y REPORTES


export const generateExcel = async (startDate, endDate,farmId,sectionId,lotId,userId,lineId,endPoint) => {
  const params = {startDate,endDate,farmId,lotId,clientId ,sectionId,userId, lineId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}` }, params, responseType: 'blob' };
  try {
    const response = await axios.get(URL_BASE + "report/"+endPoint, config);
    const contentType = response.headers['content-type'];
    if (contentType && contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
      return response.data; 
    } else {   
      const text = await response.data.text();
      const errorData = JSON.parse(text);
      throw new Error(errorData.message || "Error desconocido al generar el reporte.");
    }
  } catch (error) {
    return { error: error.message };
  }
};






export const generateHealthExcel = async (startDate, endDate,farmId,sectionId,lotId,userId,lineId,endPoint,issue) => {
  const params = {startDate,endDate,farmId,lotId,clientId ,sectionId,userId, lineId,issue };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}` }, params, responseType: 'blob' };
  try {
    const response = await axios.get(URL_BASE + "health-report/"+endPoint, config);
    const contentType = response.headers['content-type'];
    if (contentType && contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
      return response.data; 
    } else {   
      const text = await response.data.text();
      const errorData = JSON.parse(text);
      throw new Error(errorData.message || "Error desconocido al generar el reporte.");
    }
  } catch (error) {
    return { error: error.message };
  }
};


export const paginatedReport = async (page,limit,startDate, endDate,farmId,sectionId,lotId,userId,lineId,endPoint) => {
  const params = {startDate,endDate,farmId,lotId,page,limit ,sectionId,userId,lineId };
  console.log("paginatedReport",params)
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "report/"+endPoint,
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};



export const paginatedHealthReport = async (page,limit,startDate, endDate,farmId,sectionId,lotId,userId,lineId,endPoint) => {
  const params = {startDate,endDate,farmId,lotId,page,limit ,sectionId,userId,lineId };
  console.log("paginatedReport",params)
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "health-report/"+endPoint,
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};




export const supervisionReportLine = async (page,limit,startDate, endDate,farmId,sectionId,lotId, userId, lineId, operatorId,updated) => {
  const params = {startDate,endDate,farmId,lotId,page,limit ,sectionId,userId,lineId,operatorId,updated };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "report/supervision-report-line",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};


////FIN GENERICOS EXCEL Y REPORTES
////FIN GENERICOS EXCEL Y REPORTES
////FIN GENERICOS EXCEL Y REPORTES
////FIN GENERICOS EXCEL Y REPORTES



export const operatorLotReport = async (page,limit,startDate, endDate,farmId,sectionId,lotId,userId) => {
  const params = {startDate,endDate,farmId,lotId,page,limit ,sectionId,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "report/operator-lot-report",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};




export const accumulationReport = async (page,limit,startDate, endDate,farmId,sectionId,lotId,userId) => {
  const params = {startDate,endDate,farmId,lotId,page,limit ,sectionId,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "report/accumulation-report",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};



export const accumulationDuplicated = async (page,limit,startDate, endDate,farmId,sectionId,lotId,userId) => {
  const params = {startDate,endDate,farmId,lotId,page,limit ,sectionId,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "report/accumulation-duplicated",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};



export const healthDetailedReportByPalm = async (params) => {
  console.log("paginatedReport",params)
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "health-report/health-detailed-by-palm",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};



export const healthTreatmentByPalm = async (params) => {
  console.log("paginatedReport",params)
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "health-report/health-treatment-by-palm",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};


export const phenologicalReport = async (page,limit,startDate, endDate,farmId,sectionId,lotId,userId,lineId) => {
  const params = {startDate,endDate,farmId,lotId,page,limit ,sectionId,userId,lineId };
  console.log("detailedReport",params)
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "report/phenological-report",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};




export const phenologicalReportExcel = async (params) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}` }, params, responseType: 'blob' };
  try {
    const response = await axios.get(URL_BASE + "report/phenological-report-excel", config);
    const contentType = response.headers['content-type'];
    if (contentType && contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
      return response.data; 
    } else {   
      const text = await response.data.text();
      const errorData = JSON.parse(text);
      throw new Error(errorData.message || "Error desconocido al generar el reporte.");
    }
  } catch (error) {
    return { error: error.message };
  }
};



export const cycleComplianceExcel = async (params) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}` }, params, responseType: 'blob' };
  try {
    const response = await axios.get(URL_BASE + "report/cycle-compliance-excel", config);
    const contentType = response.headers['content-type'];
    if (contentType && contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
      return response.data; 
    } else {   
      const text = await response.data.text();
      const errorData = JSON.parse(text);
      throw new Error(errorData.message || "Error desconocido al generar el reporte.");
    }
  } catch (error) {
    return { error: error.message };
  }
};





export const accumulationByMonthLot = async (page,limit,startDate, endDate,farmId,sectionId,lotId,userId) => {
  const params = {startDate,endDate,farmId,lotId,page,limit ,sectionId,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "report/accumulation-by-month-lot",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};


export const accumulationByMonthLotExcel = async (startDate, endDate,farmId,sectionId,lotId,userId) => {
  const params = {startDate,endDate,farmId,lotId,clientId ,sectionId,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}` }, params, responseType: 'blob' };
  try {
    const response = await axios.get(URL_BASE + "report/accumulation-by-month-lot-excel", config);
    const contentType = response.headers['content-type'];
    if (contentType && contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
      return response.data; 
    } else {   
      const text = await response.data.text();
      const errorData = JSON.parse(text);
      throw new Error(errorData.message || "Error desconocido al generar el reporte.");
    }
  } catch (error) {
    return { error: error.message };
  }
};





export default {
  phenologicalReportExcel,
  phenologicalReport,
  detailedReport,
  consolidatedReport,
  generateDetailedExcel,
  generateConsolidatedExcel,
  supervisionMetrics,
  supervisionMetricsDaily,
  supervisionMetricsDailyExcel,
  metricsExcel,
  paymentReport,
  paymentExcel,
  consumptionReport,
  consumptionExcel,
  generateHeatMapExcel,
  palmMovements,
  generateTrackingExcel,
  accumulationReport,
  generateAccumulationExcel,
  unproductivePalms,
  accumulationByMonth,
  accumulationByMonthExcel,
  accumulationByMonthLot,
  accumulationByMonthLotExcel,
  fruitInventoryExcel,
  generateTrackingExcelAll,
  generateExcel,
  generateHealthExcel,
  paginatedReport,
  generateFirstApplicationMapExcel,
  supervisionReportLine,
  operatorLotReport,
  accumulationDuplicated,
  accumulationByLot,
  accumulationByLotExcel,
  healthDetailedReportByPalm,
  healthTreatmentByPalm,
  cycleComplianceExcel,
  paginatedHealthReport
};
